import { SnCamera } from '@lib/api/entities';
import { COLORS } from '@lib/ui/theme';
import { GoogleMapMarker, GoogleMapMarkerType, GoogleMapPopup } from '@lib/geo/google/map';

export class SnRegistryCameraMarker extends GoogleMapMarker {
  public infoWindow: GoogleMapPopup;

  constructor(public readonly camera: SnCamera) {
    super({
      id: `camera-${camera.id}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: camera.geometry.coordinates,
      title: camera.name,
    });

    this.setIcon(this._getIcon());
    this.setStyle({
      strokeColor: COLORS['light-blue-500'],
      fillColor: COLORS['light-blue-500'],
      rotation: 0,
      scale: 0.75,
    });
  }

  public setScale(scale: number): void {
    const style = this.style;

    this.setStyle({ ...style, scale });
  }

  private _getIcon(): any {
    return {
      fontSet: 'fs',
      fontIcon: 'f03d',
    };
  }
}
